import { useEffect, useRef } from "react";

const Stepper = ({ steps, activeStep, onClickHandler }) => {
    const activeElementRef = useRef(null);
    useEffect(() => {
        if (activeElementRef.current) {
            activeElementRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [activeStep]); // Re-run effect when isActive changes

    return (
        <div className="steps">{steps?.map((step, i) => <div
            ref={activeStep === (i + 1) ? activeElementRef : null}
            key={step?.label}
            onClick={() => onClickHandler(i)}
            className={`step ${activeStep > i ? 'prev' : ''} ${activeStep === (i + 1) ? 'active' : ''}`}>
            <p className="indicator" >{i + 1}</p>
            <label>{step?.label}</label>
        </div>)}</div>
    )
}

export default Stepper